import * as types from './mutations-types'
import pointsMailApi from '../../../../../api/wx-member/points-mall/points-mall'

export default {
  getRankEquityList: ({commit}, data) => {
    pointsMailApi.getRankEquityList(data)
      .then(result => {
        commit(types.RANK_EQUITY_LIST, result)
      })
  }
}



// WEBPACK FOOTER //
// ./src/pages/wx-member/points-mall/rank-equity/store/actions.js